import { Component, OnInit, Injector, Inject } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-letter-popup',
  templateUrl: './add-letter-popup.component.html',
  styleUrls: ['./add-letter-popup.component.scss'],
})
export class AddLetterPopupComponent implements OnInit {
  addlLetterName: any;
  addEmailSubject: any;
  sendIncrementEmailLetter: any;
  loggedInUserCompanyID: any;
  buttonColorName: any;
  fromYear: any;
  toYear: any;
  isInValidlLetterName: boolean = false;
  isInValidLetterSubject: boolean = false;
  isInvalidLetterBody: boolean = false;
  getIncrementFyYearList: any[] = [];
  letterNameArray: any = [];
  loggedInCompanyFiscalyear: any;
  AddLetterContent: any;
  isDisabledIncrementLetter: any = false;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter Email here...',
    defaultParagraphSeparator: '',
  }

  constructor(private encryptionService: EncryptionService, private httpService: HttpService,
    private config: Config, public dialog: MatDialog, private injector: Injector,
    public dialogRef: MatDialogRef<AddLetterPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }
  rowID: any
  colID: any
  getIncrementLetterData: any = [];
  letterId: any
  departmentName: any;
  band: any;
  ratingId: any
  letterCombination: any;
  existingLetterNames: any[] = [];
  errorMessage: any;
  bandRowId: any;
  dialogData: any

  ngOnInit() {
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.rowID = this.data.rowID || 0;
    this.colID = this.data.columnID || 0;
    this.bandRowId = this.data.bandRowId || 0;
    this.addlLetterName = this.data.existingLetterName || '';
    this.addEmailSubject = this.data.subject;
    this.departmentName = this.data.department || '';
    this.letterId = this.data.id || null;
    this.letterCombination = this.data.letterCombination || '';
    this.band = this.data.band || '';
    this.ratingId = this.data.ratingId || null;
    if (this.data.isMDApprove == true) {
      this.isDisabledIncrementLetter = true
    } else {
      this.isDisabledIncrementLetter = false
    }
    if (this.data.body == null) {
      this.AddLetterContent = `Date: [DD/MM/YYYY]&#160;<div><br></div>
    <div>To,&#160;</div><div><br></div>
    <div>[Employee's Name]&#160;</div>
    <div>[Employee's Designation]&#160;</div>
    <div>[Department]&#160;</div>
    <div>[Employee's office location]</div>
    <div>&#160;</div>
    <div>Subject:- Salary Increment Notification&#160;</div>
    <div><br></div>
    <div>Dear [Employee's Name],&#160;</div>
    <div><br></div>
    <div>Basis your annual performance for the year 23-24, you have been awarded a performance rating of [rating] and we are pleased to inform you basis your band, your effective all inclusive increment %ge is [Increment %ge]. This increment reflects your hard work, dedication, and the significant contributions you have made to the company. Your revised annual CTC post increment is [New annual CTC Amount].&#160;</div>
    <div>Promotion content: We are also delighted to inform that you have been promoted wef 1st April 2024 and your new designation is [revised designation]. Please note that the revised salary will be effective from 1st April 2024 and will reflect in your payslip.&#160;</div>
    <div>We appreciate your continued efforts and dedication to your role. If you have any questions or require further clarification regarding this increment, please feel free to reach out to the HR department.&#160;</div>
    <div><span>Congratulations!!&#160;</span></div>
    <div><br></div>
    <div>Sincerely,</div>
    <div><br></div>
    <div>Digital signature</div>
    <div>Name of Head HR&#160;</div>
    <div>Designation</div>`;
    } else {
      this.AddLetterContent = this.data.body;
    }
    this.getIncrementFyYear();
  }

  isValicIncrementLetter() {
    this.isInValidlLetterName = !this.addlLetterName?.trim();
    this.isInValidLetterSubject = !this.addEmailSubject?.trim();
    this.isInvalidLetterBody = !this.AddLetterContent?.trim();
  }

  getIncrementFyYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        fromYear: ele.fromYear,
        toYear: ele.toYear,
        year: `${ele.fromYear}-${ele.toYear}`,
      }));
      const currentYear = new Date().getFullYear();
      let yearValue = '';

      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.fromYear = this.getIncrementFyYearList[selectedYearIndex].fromYear;
      this.toYear = this.getIncrementFyYearList[selectedYearIndex].toYear;
    })
  }

  onClickSaveBtn() {
    const lettersName = sessionStorage.getItem('LettersName');
    this.letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    this.isValicIncrementLetter();

    if (!this.isInValidlLetterName && !this.isInValidLetterSubject && !this.isInvalidLetterBody) {
      this.isInValidlLetterName = false;
      this.isInValidLetterSubject = false;
      this.isInvalidLetterBody = false;
      const LetterTextContent = this.stripHtmlTags(this.AddLetterContent);

      if (this.letterNameArray.includes(this.addlLetterName.trim())) {
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully added',
            btn1: 'Cancel',
            btn2: 'Yes',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const formData = {
              rowId: this.rowID,
              bandRowId: this.bandRowId,
              colId: this.colID,
              body: this.AddLetterContent,
              letterName: this.addlLetterName,
              subject: this.addEmailSubject,
              department: this.departmentName,
              id: this.letterId
            };
            this.dialogRef.close(formData);
            this.letterNameArray.push(this.addlLetterName.trim());
            sessionStorage.setItem('LettersName', JSON.stringify(this.letterNameArray));
          }
        });
      }
    }
  }

  stripHtmlTags(content: string): string {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.innerText;
  }

  onClickDiscardChanges() {
    const lettersName = sessionStorage.getItem('LettersName');
    this.letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    this.addlLetterName = " ";
    this.addEmailSubject = " ";
    this.sendIncrementEmailLetter = " ";
    this.isInValidlLetterName = false;
    this.isInValidLetterSubject = false;
    this.isInvalidLetterBody = false;
    this.letterNameArray.push(this.addlLetterName.trim());
    sessionStorage.setItem('LettersName', JSON.stringify(this.letterNameArray));
    this.dialogRef.close();
  }

  onClickRemoveLetterSubject() {
    if (this.dialogData !== null) {
      this.addEmailSubject = '';
    }
  }

  onClickClosePopup() {
    if (this.data.existingLetterName == null) {
      this.dialogRef.close();
    } else {
      const lettersName = sessionStorage.getItem('LettersName');
      this.letterNameArray = lettersName ? JSON.parse(lettersName) : [];

      this.letterNameArray.push(this.data.existingLetterName.trim());
      sessionStorage.setItem('LettersName', JSON.stringify(this.letterNameArray));
      this.dialogRef.close();
    }
  }
}
